export default {
  // Login y recuperación de contraseña (migrado desde navigation.js → login)
  login: {
    'username-label': 'Enter username',
    'password-label': 'Enter password',
    'welcome': 'Welcome',
    'login': 'Login',
    'email': 'Email',
    'forgot-password': 'Forgot your password?',
    'remember-me': 'Remember me',
    'spanish-label': 'Español',
    'english-label': 'English',
    'credentials-alert': 'Invalid credentials',
    'ingresarCodigo': 'Enter Code',
    'reset-password-title': 'Reset your password',
    'reset-password-subtitle-p1': 'To restore your password,',
    'reset-password-subtitle-p2': ' enter your email address.',
    'reset-password-text': 'Choose the reset method:',
    'reset-password-mail': 'Send link via email',
    'reset-password-sms': 'Send code via SMS',
    'reset-password-error-email': 'Email not found',
    'reset-password-sms-title': 'Enter the code we sent you by SMS.',
    'reset-password-sms-subtitle': 'It’s a 6-digit code sent to the finished phone at',
    'reset-password-mail-success': 'We have sent a link to your email',
    'reset-password-mail-success-caption': 'Link with instructions sent to the email, check your spam folder',
    'reset-password-mail-not-recieve': 'Didn’t you get the email?',
    'reset-password-mail-resend': 'Resend Email 00:',
    'reset-password-mail-resend-btn': 'Resend Email',
    'reset-password-sms-resend': 'Resend SMS',
    'email-send-success': 'Email sent successfully',
    'password-changed-success': 'Password changed successfully',
    'password-changed-success-info': 'You will be redirected to the login module at: ',
    'continue': 'continue',
    'cancel': 'cancel',
    'not-you': 'Not you?',
    'back': 'Back Home',
    'cancel-sms-reset': 'Cancel and return to login',
    'create-password': 'Create a new password',
    'enter-password': 'Enter your new password',
    'confirm-password': 'Confirm your new password',
    'change-password': 'Change Password',
    'required-password': 'Your new password must contain the following:',
    'biometric-login': 'Sign in with biometrics',
    'biometric-enable-title': 'Enable biometric sign-in.',
    'biometric-enable-message': 'Turn on your fingerprint or face recognition to sign in without a password next time.',
    'biometric-enable-confirm': 'Enable biometrics',
    'biometric-enable-dismiss': 'Not now',
    'biometric-login-error': 'We could not verify your biometric identity',
    'biometric-login-prompt-title': 'Biometric sign-in',
    'biometric-login-prompt-description': 'Confirm your identity to continue',
    'biometric-enroll-prompt-title': 'Enable biometric login',
    'biometric-enroll-prompt-description': 'Confirm your identity to enable biometric login',
    'biometric-reenroll-required': 'Your biometric login expired, sign in with your password to re-enable it'
  },

  // Formulario de cambio de contraseña (migrado desde profile.js → auth)
  password_form: {
    password: 'Password',
    password_verify: 'Confirm password',
    change_password: 'Update password',
    save: 'Save'
  },

  // Autenticación en dos pasos (migrado desde profile.js — success_2fa/error_2fa/success_deactivate2fa)
  two_factor: {
    success: 'Next time you log in you will need to use the code generated from Google Authenticator.',
    deactivated: 'Next time you log in you will not be asked for the code',
    error: 'The code is not correct'
  }
}
